import Grid from "@mui/material/Grid";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ClearIcon from '@mui/icons-material/Clear';
import React, {useState} from "react";
import {toast} from "react-toastify";
import {IconButton} from "@mui/material";

export let uploadedFiles
const DragAndDrop = ({inputUpdated}) => {

    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes
    const FileErrorMessage = "Please choose a file that is less than 5MB"
    const FileTypeErrorMessage = "Please ensure document is of type: PDF, DOCX or XLSX"
    const [selectedFiles, setSelectedFiles] = useState([]);
    // ref
    const inputRef = React.useRef(null);

    const showSaveError = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_LEFT,
            style: {
                backgroundColor: "#eb4335",
                width: "650px",
                color: "#FFFFFF",
                left: "500px",
                theme: "colored",
            },
        });
    };

    function getFileExtension(filename) {
        return filename.split('.').pop();
    }

    // handle drag events
    const handleDrag = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };

    // triggers when file is dropped
    const handleDrop = (e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        handleFileSelected(files);
    };

    // triggers when file is selected with click
    const handleDocumentChange = function (e) {
        e.preventDefault();
        const files = e.target.files;
        handleFileSelected(files);
    };

    // Core functionality for drag and drop or manual file selection
    const handleFileSelected = function (files) {
        const selectedFileLinks = [];
        const fileUrls = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileType = getFileExtension(file.name)
            console.log(fileType)
            if (file.size > MAX_FILE_SIZE) {
                showSaveError(FileErrorMessage);
            }else if(!(fileType === "pdf" || fileType==="docx" || fileType==="xlsx")){
                showSaveError(FileTypeErrorMessage)
            }else {
                const fileUrl = URL.createObjectURL(file);

                fileUrls.push(fileUrl);
                selectedFileLinks.push(
                    < a href={fileUrls[i]} key={i} target="_blank" rel="noopener noreferrer"
                        style={{fontSize: "small", marginRight: "10px"}}>
                        {file.name}
                    </a>
                );
            }
        }
        setSelectedFiles(selectedFileLinks);
        uploadedFiles = files;

        inputUpdated(uploadedFiles);
    }

    // triggers the input when the button is clicked
    const onButtonClick = (e) => {
        e.preventDefault();
        inputRef.current.click();
    };

    const removeFile = (e) => {
        e.preventDefault()
        setSelectedFiles([]);
        handleFileSelected([]);
    }

    return (
        <form
            id="form-file-upload"
            data-testid={"form-file-upload"}
            onDragOver={handleDrag}
            onDragLeave={handleDrag}
            onDrop={handleDrop}
            onSubmit={(e) => e.preventDefault()}
            draggable={"true"}
            className={"inputWidth"}
        >
            <input
                ref={inputRef}
                type="file"
                id="input-file-upload"
                data-testid={"input-file-upload"}
                multiple={true}
                onChange={handleDocumentChange}
            />
            <label
                className="UploadInputWidth"
                id="label-file-upload"
                htmlFor="input-file-upload"
            >
                <Grid container direction="column" className="DragDropText">
                    <Grid item style={{color: "#FF6600"}}>
                        <UploadFileIcon/>
                    </Grid>
                    <button className="upload-button" onClick={onButtonClick}>
                        Click to Upload
                    </button>
                    or drag and drop
                    <Grid item>PDF, DOCX or XLSX (max.5MB)</Grid>
                    <div data-testid={"selected-files-links"}>{selectedFiles}<IconButton data-testid={"removeDocument"} hidden={selectedFiles.length <= 0} onClick={removeFile}>
                        <ClearIcon/>
                    </IconButton></div>
                </Grid>
            </label>
        </form>
    )
}

export default DragAndDrop;